import React, { useEffect, useState } from "react";
import { useModal } from "../../../components/ContextApi/modal/modalContext";
import { createPublicCharacter } from "../../../store/character/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getSocket, initializeSocket } from "../../../helpers/socket";
import { useNavigate } from "react-router-dom";

const Step11 = ({
  imageGenerated,
  setImageGenerated,
  kinks,
  relationship,
  occupation,
  chatStyle,
  sexOrientation,
  traits,
  personality,
  eye,
  hairColor,
  hairStyle,
  butt,
  boobs,
  physique,
  height,
  ethnicBackground,
  age,
  art,
  gender,
  step,
  setStep,
  appearanceList,
  appearanceLoading,
}) => {
  const { openModal, closeModal } = useModal();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.Auth);
  const userId = user?._id;
  const authState = useSelector((state) => state.Auth);
  const authenticate = authState.isAuthenticated;
  const [socket, setSocket] = useState(null);
  console.log(userId, "useruser");

  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    const socket = getSocket();
    if (socket) {
      setSocket(socket);
    }
  }, []);

  const aiObject = {
    gender: gender,
    art: art,
    age: age,
    ethnicBackground: ethnicBackground,
    height: height,
    physique: physique,
    boobs: boobs,
    butt: butt,
    hairStyle: hairStyle,
    hairColor: hairColor,
    eye: eye,
    personality: personality,
    traits: traits,
    sexOrientation: sexOrientation,
    chatStyle: chatStyle,
    occupation: occupation,
    relationship: relationship,
    kinks: kinks,
    type: "public",
    isRequestedPublic: "personal",
  };

  // ✅ STEP 1: Initialize socket when component mounts
  useEffect(() => {
    if (!socket) {
      console.log("🔌 Initializing socket for user:", userId);
      const socketInstance = initializeSocket(userId);
      setSocket(socketInstance);

      // Verify socket connection
      if (socketInstance) {
        console.log("✅ Socket instance created:", socketInstance.id);
      }
    }
  }, [socket, userId]);

  // ✅ STEP 2: Set up socket listener IMMEDIATELY when socket is available

  useEffect(() => {
    if (!socket) {
      console.warn("⚠️ Socket not available yet");
      return;
    }

    console.log(
      "👂 Setting up image_Notification listener on socket:",
      socket.id,
    );

    // Handler function
    const handleImageNotification = (payload) => {
      console.log("📨 Received socket event:", payload);
      console.log("Event type:", payload.type);
      console.log("Event status:", payload.status);
      console.log("Event data:", payload.data);

      if (payload.type === "Character") {
        if (payload.status === "processing") {
          console.log("⏳ Character is being processed...");
          toast.info("Generating your character...");
        } else if (payload.status === "success") {
          console.log("✅ Character generation SUCCESS!");
          console.log("Character data:", payload.data);
          console.log("Image URL:", payload.data?.image);

          // Close loading modal
          closeModal();

          // Update state with generated character
          setImageGenerated(payload.data);

          // Move to final step
          // setStep("final");
          navigate("/public-character");

          // Reset creating state
          setIsCreating(false);

          toast.success("Character generated successfully!");
        } else if (payload.status === "failed") {
          console.error("❌ Character generation FAILED");
          console.error("Error:", payload.message);

          closeModal();
          setIsCreating(false);
          toast.error(payload.message || "Failed! Please try again!");
        }
      }
    };

    // ⭐ CHANGED: Listen to "image_Notification" instead of "image_generated"
    socket.on("image_Notification", handleImageNotification);

    console.log("✅ Listener attached successfully");

    // Cleanup on unmount
    return () => {
      console.log("🧹 Cleaning up socket listener");
      socket.off("image_Notification", handleImageNotification);
    };
  }, [socket, closeModal, setImageGenerated, setStep]);

  // ✅ STEP 3: Handle create AI button click
  const handleCreateAi = () => {
    console.log("icclicked");
    if (isCreating) {
      console.warn("⚠️ Already creating a character, please wait...");
      toast.warning("Character creation already in progress");
      return;
    }

    console.log("🚀 Starting character creation...");
    console.log("Socket ID:", socket?.id);
    console.log("User ID:", userId);
    console.log("AI Object:", aiObject);

    // Set creating state
    setIsCreating(true);

    // Open loading modal
    openModal("generate-loading-pop");

    // Callback from API
    const callBack = (err, response) => {
      if (err) {
        console.error("❌ API Error:", err);
        closeModal();
        setIsCreating(false);
        toast.error(err.message || "Failed to create character");
        return;
      }

      console.log("✅ API Response received:", response);
      console.log("Character ID:", response?.data?.character?._id);

      // Don't close modal yet - wait for socket event
      // toast.info("Character created! Generating image...");

      // Note: Modal will close when socket event arrives with status="success"
    };

    // Dispatch API call
    dispatch(
      createPublicCharacter({
        data: aiObject,
        callBack,
      }),
    );
  };

  console.log(aiObject, "imageGenerated");

  return (
    <>
      <div className="mx-auto flex flex-col gap-4">
        {/* <div className="text-center">
          <h4 className="m-0 text-[20px]">CREATE YOUR AI CHARACTER</h4>
          <p className="m-0 py-2 font-normal">Take Control of your Character</p>
        </div> */}
        <div className="">
          <div className="mx-auto mt-5 rounded-[12px]">
            {/* <div className="top pb-3 text-center">
              <h6 className="m-0 py-2 font-semibold text-[20px]">
                Madison Parker is 90% ready
              </h6>
            </div>
            <div className="grid gap-4 grid-cols-12">
              <div className="lg:col-span-3 md:col-span-4 sm:col-span-6 col-span-12">
                <img
                  src={"/assets/media/create-ai/c11m.png"}
                  alt=""
                  height={1000}
                  width={1000}
                  className="max-w-full h-auto w-full"
                />
              </div>
              <div className="lg:col-span-9 md:col-span-8 sm:col-span-6 col-span-12 md:pl-8">
                <button
                  className="m-0 border-0 p-0 bg-transparent text-[18px] inline-flex items-center gap-2 font-medium"
                >
                  Generate Name {regenerateIcn}
                </button>
                <div className="my-3 flex items-center gap-2">
                  {radioIcn}
                  <label htmlFor="name" className="form-label m-0">
                    Madison Parker
                  </label>
                </div>
                <div className="py-3">
                  <ul className="list-none pl-0 mb-0 flex flex-col gap-4 md:gap-y-8">
                    <li className="">
                      <div className="bg-[#dfdfdf] border font-medium rounded-[12px] px-4 py-3 md:p-5">
                        <h6 className="m-0 text-[18px]">Bio</h6>
                        <p className="m-0 pt-2">
                          Madison is 24 years old, straight Caucasian female
                          nurse
                        </p>
                      </div>
                    </li>
                    <li className="">
                      <div className="bg-[#dfdfdf] border font-medium rounded-[12px] px-4 py-3 md:p-5">
                        <h6 className="m-0 text-[18px]">Body</h6>
                        <p className="m-0 pt-2">
                          Slim shapes, Slim butt and Small sized breasts
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
            <div className="grid gap-4 grid-cols-12">
              <div className="md:col-span-4 sm:col-span-6 col-span-12">
                {/* <img
                  src={
                    aiObject.art === "Realistic"
                      ? "/assets/media/create-ai/c11.png"
                      : "/assets/media/create-ai/c12.png"
                  }
                  alt=""
                  height={1000}
                  width={1000}
                  className="max-w-full h-auto w-full rounded-xl"
                /> */}
                <video
                  key={`${aiObject.art}-${aiObject.gender}`}
                  style={{ aspectRatio: 262 / 332 }}
                  className="max-w-full h-auto w-full object-cover rounded-[8px] object-top"
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster={
                    aiObject.art === "Realistic"
                      ? `/assets/media/create-ai/${aiObject.gender === "male" ? "mrealistic" : "realistic"}.jpg`
                      : `/assets/media/create-ai/${aiObject.gender === "male" ? "manime" : "anime"}.jpg`
                  }
                >
                  <source
                    src={
                      aiObject.art === "Realistic"
                        ? `/assets/media/create-ai/${aiObject.gender === "male" ? "mrealistic" : "realistic"}.mp4`
                        : `/assets/media/create-ai/${aiObject.gender === "male" ? "manime" : "anime"}.mp4`
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="md:col-span-8 sm:col-span-6 col-span-12">
                <div className="grid gap-3 grid-cols-12 md:pl-10">
                  <div className="md:col-span-4 col-span-6 py-2">
                    <div className="flex items-center gap-2">
                      <div className="icnWrp">🌎</div>
                      <div className="content text-xs">
                        <p className="m-0 text-[#a3a3a3]">Ethnicity</p>
                        <p className="m-0">{aiObject.ethnicBackground}</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-6 py-2">
                    <div className="flex items-center gap-2">
                      <div className="icnWrp">🎂</div>
                      <div className="content text-xs">
                        <p className="m-0 text-[#a3a3a3]">Age</p>
                        <p className="m-0">{aiObject.age}</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-6 py-2">
                    <div className="flex items-center gap-2">
                      <div className="icnWrp">🤸</div>
                      <div className="content text-xs">
                        <p className="m-0 text-[#a3a3a3]">Body type</p>
                        <p className="m-0">{aiObject.physique}</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-6 py-2">
                    <div className="flex items-center gap-2">
                      <div className="icnWrp">👁️</div>
                      <div className="content text-xs">
                        <p className="m-0 text-[#a3a3a3]">Eyes</p>
                        <p className="m-0"> {aiObject.eye}</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-6 py-2">
                    <div className="flex items-center gap-2">
                      <div className="icnWrp">💇🏽‍♀️</div>
                      <div className="content text-xs">
                        <p className="m-0 text-[#a3a3a3]">Hair style</p>
                        <p className="m-0"> {aiObject.hairStyle}</p>
                      </div>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-6 py-2">
                    <div className="flex items-center gap-2">
                      <div className="icnWrp">👩</div>
                      <div className="content text-xs">
                        <p className="m-0 text-[#a3a3a3]">Hair color</p>
                        <p className="m-0">{aiObject.hairColor}</p>
                      </div>
                    </div>
                  </div>
                  {gender == "female" && (
                    <>
                      <div className="md:col-span-4 col-span-6 py-2">
                        <div className="flex items-center gap-2">
                          <div className="icnWrp">🍒</div>
                          <div className="content text-xs">
                            <p className="m-0 text-[#a3a3a3]">Breasts</p>
                            <p className="m-0">{aiObject.boobs}</p>
                          </div>
                        </div>
                      </div>
                      <div className="md:col-span-4 col-span-6 py-2">
                        <div className="flex items-center gap-2">
                          <div className="icnWrp">🍑</div>
                          <div className="content text-xs">
                            <p className="m-0 text-[#a3a3a3]">Butt</p>
                            <p className="m-0">{aiObject.butt}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-[80px] mx-auto max-w-[516px] w-full">
          <button
            disabled={isCreating}
            onClick={() => {
              // if (!authenticate) {
              //   openModal("login");
              // } else if (!isCreating) {
              // }
              handleCreateAi();
            }}
            className={`  ${isCreating && "opacity-50 cursor-not-allowed"} flex items-center justify-center gap-2 h-[45px] bg-[#E443A6] w-full px-3 rounded-[10px] text-white font-medium`}
          >
            {isCreating ? "Creating..." : "Next"} {rightIcn}
          </button>
        </div>
      </div>
    </>
  );
};

export default Step11;

const regenerateIcn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0007 3.33398V0.833984L6.66732 4.16732L10.0007 7.50065V5.00065C12.759 5.00065 15.0007 7.24232 15.0007 10.0007C15.0007 10.8423 14.7923 11.6423 14.4173 12.334L15.634 13.5507C16.3092 12.4897 16.6677 11.2582 16.6673 10.0007C16.6673 6.31732 13.684 3.33398 10.0007 3.33398ZM10.0007 15.0007C7.24232 15.0007 5.00065 12.759 5.00065 10.0007C5.00065 9.15899 5.20898 8.35898 5.58398 7.66732L4.36732 6.45065C3.69211 7.51156 3.33363 8.7431 3.33398 10.0007C3.33398 13.684 6.31732 16.6673 10.0007 16.6673V19.1673L13.334 15.834L10.0007 12.5007V15.0007Z"
      fill="#E7E6F8"
    />
  </svg>
);

const rightIcn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 10.0013C17.5 10.4613 17.1267 10.8346 16.6667 10.8346H3.33333C2.87333 10.8346 2.5 10.4613 2.5 10.0013C2.5 9.5413 2.87333 9.16797 3.33333 9.16797H16.6667C17.1267 9.16797 17.5 9.5413 17.5 10.0013Z"
      fill="white"
    />
    <path
      d="M15.8115 10.0002C15.734 9.87103 15.5707 9.63936 15.3923 9.4377C15.0382 9.03603 14.549 8.5777 14.0382 8.13436C13.5323 7.6952 13.0232 7.28686 12.6398 6.98686C12.4482 6.8377 12.1182 6.58853 12.0073 6.50436C11.6365 6.23186 11.5573 5.7102 11.8307 5.33936C12.1032 4.96853 12.6248 4.88936 12.9957 5.1627L12.999 5.1652C13.119 5.25603 13.4682 5.51936 13.6648 5.67353C14.0632 5.98353 14.5957 6.41103 15.1315 6.87603C15.6623 7.33686 16.2148 7.85186 16.6415 8.33436C16.854 8.57436 17.0532 8.82686 17.2032 9.07603C17.339 9.30186 17.5015 9.63103 17.5015 10.0002C17.5015 10.3694 17.339 10.6985 17.2032 10.9244C17.0532 11.1735 16.854 11.426 16.6415 11.666C16.2148 12.1485 15.6623 12.6635 15.1315 13.1244C14.5957 13.5894 14.0632 14.0169 13.6648 14.3269C13.4682 14.481 13.119 14.7444 12.999 14.8352L12.9957 14.8377C12.6248 15.111 12.1032 15.0319 11.8307 14.661C11.5573 14.2902 11.6365 13.7685 12.0073 13.496C12.1182 13.4119 12.4482 13.1627 12.6398 13.0135C13.0232 12.7135 13.5323 12.3052 14.0382 11.866C14.549 11.4227 15.0382 10.9644 15.3923 10.5627C15.5707 10.361 15.734 10.1294 15.8115 10.0002Z"
      fill="white"
    />
  </svg>
);

const checkIcn = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.71Z"
      fill="currentColor"
      fillOpacity="1"
    />
  </svg>
);

const radioIcn = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#E443A6" />
    <circle cx="10" cy="10" r="7" fill="#E443A6" />
  </svg>
);
